module.exports = __webpack_public_path__ + "img/b949fd1.jpg";